"use strict";

exports.__esModule = true;
exports.default = void 0;
var _all = _interopRequireDefault(require("../../../data/all.json"));
var _nimbleEmojiIndex = _interopRequireDefault(require("./nimble-emoji-index"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var emojiIndex = new _nimbleEmojiIndex.default(_all.default);
var emojis = emojiIndex.emojis,
  emoticons = emojiIndex.emoticons;
function search() {
  return emojiIndex.search.apply(emojiIndex, arguments);
}
var _default = exports.default = {
  search: search,
  emojis: emojis,
  emoticons: emoticons
};